var invariantFor = function (type) { return function (condition, parameter, value, message, source) {
    if (source === void 0) { source = '/transformation_reference'; }
    if (!condition) {
        value = typeof value === 'string' ? "'" + value + "'" : value;
        source = source ? "http://cloudinary.com/documentation" + source : null;
        throw new Error("Cloudinary " + type + ":: " + parameter + " " + message + ", received: " + value + (source ? " - see " + source : ''));
    }
}; };
export var invariantImage = invariantFor('Image ');
export var isNumber = function (value) {
    return typeof value === 'number' || !Number.isNaN(Number(value));
};
export var shouldBeOneOf = function (possibleValues) {
    return "should be one of ['" + possibleValues.join("', '") + "']";
};
export var startsWith = function (needle, haystack) { return haystack.indexOf(needle) === 0; };
export var includes = function (needle, haystack) { return haystack.indexOf(needle) > -1; };
